import { render, staticRenderFns } from "./SeriDataTable.vue?vue&type=template&id=6bd2b0d3&"
import script from "./SeriDataTable.vue?vue&type=script&lang=js&"
export * from "./SeriDataTable.vue?vue&type=script&lang=js&"
import style0 from "./SeriDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports